<template>
  <div class="container">
    <!-- <div class="title">
      问题反馈
    </div> -->
    <van-form >
      <van-field
        v-model="feedback"
        name="被反馈人/单位"
        label="被反馈人/单位"
        placeholder="请输入"
      />
      <div class="label">反馈内容<span class="red"> *</span>
        <hr>
      </div>
      <van-field
        v-model="content"
        type="textarea"
        name="反馈内容"
        label=""
        maxlength="500"
        show-word-limit
        placeholder="请填写反馈内容"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field name="radio" label="反馈类型">
        <template #input>
          <van-radio-group v-model="feedbackType" @change="onConfirm" direction="horizontal">
            <van-radio name="匿名反馈">匿名反馈</van-radio>
            <van-radio name="署名反馈">署名反馈</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div v-if="isShowUser">
        <van-field
          v-model="username"
          type="text"
          name="反馈人"
          placeholder="请填写反馈人"
          :rules="[{ required: true, message: '' }]"
        >
          <div slot="label" class="flex" >
            <span class="filed-label">反馈人</span>
            <span class="red"> *</span>
          </div>
        </van-field>
        <van-field
          v-model="phoneNumber"
          type="text"
          name="联系电话"
          placeholder="请填写联系电话"
          :rules="[{ required: true, message: '' }]"
        >
        <div slot="label" class="flex" >
            <span class="filed-label">联系电话</span>
            <span class="red"> *</span>
          </div>
        </van-field>
        <van-field
          v-model="idCard"
          type="text"
          name="身份证"
          placeholder="请填写身份证号码"
        >
        <div slot="label" class="flex" >
            <span class="filed-label">身份证</span>
          </div>
        </van-field>
        <van-field
          v-model="company"
          type="text"
          name="单位"
          label="单位"
          placeholder="请填写单位"
        />
      </div>
      
      <div class="label" style="margin-top:16px">上传图片</div>
      <van-field name="uploader" >
        <template #input>
          <van-uploader v-model="uploader" />
        </template>
      </van-field>
      <div class="check">
        <van-checkbox  shape="square" v-model="checked">我承诺:我本次反馈坚持实事求是原则，如实反馈情况，不捏造事实，诬告陷害。自愿对反馈的内容承担法律责任。</van-checkbox>
      </div>
      <div class="check">
        <span>包含<span class="red">*</span>的选项为必填项</span>
      </div>
      <div class="footer1">
        <van-button  block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
    <div class="bg" v-if="isLoading"><van-loading color="#0094ff" >保存中...</van-loading></div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { Notify } from 'vant';

export default {
  name: "index",
  components: {},
  data() {
    return {
      checked:false,
      showPicker:false,
      feedbackType:'匿名反馈',
      isShowUser:false,
      columns: ['署名反馈', '匿名反馈'],
      username:'',
      phoneNumber:'',
      idCard:'',
      company:'',
      content:'',
      feedback:'',
      // uploader: [{ url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }],
      uploader: [],
      isLoading:false
    };
  },
  created() {

  },
  mounted() {
    // document.title = '首页';
  },
  methods: {
    onSubmit(values) {
      console.log('submit', values);
      if(this.feedbackType==''){
        Dialog.alert({
          title: '提示',
          message: '请选择反馈类型',
        }).then(() => {
          // on close
        });
      } else if(this.feedbackType=='匿名反馈'&&this.content==''){
        Dialog.alert({
          title: '提示',
          message: '请填写完整的基本信息',
        }).then(() => {
          // on close
        });

      } else if(this.feedbackType=='署名反馈'&&(this.content==''||this.username==''||this.phoneNumber==''||this.company=='')){
        Dialog.alert({
          title: '提示',
          message: '请填写完整的基本信息',
        }).then(() => {
          // on close
        });

      }else{
        console.log(this.checked);
        if(!this.checked){
          Dialog.alert({
            title: '提示',
            message: '请确认并勾选承诺信息',
          }).then(() => {
            // on close
          });
        }else{
          var objData = new FormData()
          objData.append('feedbackType', this.feedbackType)
          objData.append('feedback', this.feedback)
          objData.append('feedbackDetail', this.content)
          objData.append('feedbackPerson', this.username)
          objData.append('contactPhone', this.phoneNumber)
          objData.append('affiliateUnit', this.company)
          objData.append('idCard', this.company)
          this.uploader.forEach(function (item) {
            objData.append('fileList',item.file)
          })
          this.isLoading = true
          this.axios({
            method: "post",
            url: "/xffeed/feedback/createFeedback",
            data: objData,
            headers: {
              'Content-type': 'multipart/form-data'
            },
          }).then((res) => {
            console.log(res)
            this.isLoading = false
            Notify({ type: 'success', message: '提交成功！',duration: '1000'  });
            setTimeout(() => {
              this.content='';
              this.username='';
              this.phoneNumber='';
              this.company=''
              this.feedback = ''
              this.idCard = ''
              this.feedbackType = '匿名反馈'
              this.checked = false
              this.uploader = []
              this.$router.push('/')
            } , 1000);

          });
          
        }
      }
    },
    onConfirm(value) {
      console.log('confirm', value);
      this.feedbackType = value;
      if(value=='署名反馈'){
        this.isShowUser = true
      }else{
        this.content='';
        this.username='';
        this.phoneNumber='';
        this.company=''
        this.feedback = ''
        this.idCard = ''
        this.feedbackType = '匿名反馈'
        this.uploader = []
        this.checked = false

        this.isShowUser = false
      }
      this.showPicker = false;
    },
  },
};
</script>
<style>
/* 屏蔽chrome浏览器默认项输入框背景色 */
input:-internal-autofill-previewed,
input:-internal-autofill-selected {
  transition: background-color 999999999s !important;
}
.container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10px;
  margin: 0 auto;
  background: #f5f5f5;
}
.van-form {
  overflow-y: auto;
  height: calc(100% - 90px);
}
.title {
  box-sizing: border-box;
  padding-top: 30px;
  margin: 30px auto;
  margin-top: 0;
  text-align: center;
}
.check {
  padding: 10px;
  margin: 16px 0;
  background: #fff;
}
.label {
  padding: 16px;
  padding-bottom: 0;
  background: #fff;
}
.label hr {
  height: 1px;
  margin-top: 10px;
  background: #ebedf0;
  border: none;
}
.van-field__label {
  width: 8em;
  color: #000;
}
.van-checkbox__label {
  color: #000;
}
.footer1 {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background: #fff;
}
.van-button {
  width: 343px;
  margin: 16px auto;
}
.red {
  color: red;
}
.bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .7);
}
.van-loading {
  margin-top: 50%;
  text-align: center;
}
</style>